import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import "./MatchInfo.css";
import { useConfig } from "../../context/ConfigContext";

export default function MatchInfo() {
  const revealRef = useRef([]);
  const [Details, setDetails] = useState({})
  const [Timeline, setTimeline] = useState([])

  const { config } = useConfig()

  const ApiUrl = config.REACT_APP_GET_MATCH_URL
  const ApiKey = config.REACT_APP_API_KEY

  useEffect(() => {
    const els = revealRef.current;
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) e.target.classList.add("show");
        });
      },
      { threshold: 0.15 }
    );
    els.forEach((el) => el && obs.observe(el));
    return () => obs.disconnect();
  }, []);

  useEffect(() => {
    const getData = async() => {
      const res = await fetch(ApiUrl, 
        { headers: { "Api-Key": ApiKey } }
      )
      const data = await res.json()

      setDetails({ 
        date: data.date,
        kickoff: data.kickoff,
        venue: data.venue,
        teams: data.teams,
        address: data.address
       })

       setTimeline(data.timeline)

    }
    getData()
  }, [ApiKey, ApiUrl])

  return (
    <section className="match-page">
      <div className="header">
        <h1>Match Information</h1>
        <p className="intro">All you need to know for the annual Beth Branson Memorial Match. Join us for an evening of rugby and community in Beth’s honour.</p>
      </div>

      <div className="cards">
        <article className="card reveal" ref={(el) => (revealRef.current[0] = el)}>
          <h2>About the Match</h2>
          <p>
            The Beth Branson Memorial Match brings friends, family, and supporters together to celebrate Beth’s life and raise funds for causes close to her heart. Expect a welcoming atmosphere, great rugby, and meaningful community spirit.
          </p>
        </article>

        <article className="card reveal" ref={(el) => (revealRef.current[1] = el)}>
          <h2>Event Details</h2>
          <ul className="details">
            <li><span>Date</span><strong>{Details.date}</strong></li>
            <li><span>Kick-off</span><strong>{Details.kickoff}</strong></li>
            <li><span>Venue</span><strong>{Details.venue}</strong></li>
            <li><span>Teams</span><strong>{Details.teams}</strong></li>
            <li><span>Location</span><strong>{Details.address}</strong></li>
          </ul>
        </article>

        <article className="card reveal" ref={(el) => (revealRef.current[2] = el)}>
          <h2>How to Attend / Support</h2>
          <p>
            Everyone is welcome. Arrive early to enjoy the atmosphere and refreshments. If you can’t attend but would like to support, you can donate online and help us make a difference in Beth’s name.
          </p>
          <div className="cta-row">
            <Link to="https://square.link/u/wcHJPHfK?src=sheet" target="_blank" rel="noreferrer" className="btn primary">Donate Now</Link>
            <a href="https://maps.google.com/?q=Bridgwater%20%26%20Albion%20Rugby%20Club" className="btn ghost" target="_blank" rel="noreferrer">Directions</a>
          </div>
        </article>
      </div>

      <div className="timeline card reveal" ref={(el) => (revealRef.current[3] = el)}>
        <h2>Match Day Timeline</h2>
        <ol className="time-list">
          {Timeline.map((t, i) => (
            <li key={i}>
              <div className="dot" aria-hidden />
              <div className="row">
                <time>{t.time}</time>
                <span>{t.label}</span>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}